import type { Dict } from "../core.js";
import type { acquisitionOps as vi } from "../vi/acquisitionOps.js";

/** Namespace `acquisitionOps` — PLAT-2026-173: the "VN invoice fetch server" screen (read-only). */
export const acquisitionOps: Dict<typeof vi> = {
  title: "VN invoice fetch server",
  subtitle: "Collector status for fetching invoices from the tax portal: queue, errors, run parameters. Read-only, computed when you open the page or press Refresh (no polling, no extra load).",
  refresh: "Refresh",
  loadFailed: "Could not read the status from bube-einvoice.",
  notConfigured: "bube-einvoice is not connected to the collector (not configured).",
  unavailable: "The collector is not answering right now. Old data is not shown to avoid misleading numbers.",
  generatedAt: "Captured at {time} (cached up to 30 seconds)",
  secRunner: "Runner",
  runnerOn: "On",
  runnerOff: "Off",
  restored: "Synchronised after restore",
  notRestored: "Not synchronised after restore — runner must stay off",
  accounts: "Concurrent accounts: {n}",
  interval: "Minimum gap between requests: {n} ms",
  slice: "One slice: up to {ms} ms · {invoices} invoices · {requests} requests",
  secCooldown: "Tax portal throttling (429)",
  cooldownOn: "Resting until {time}",
  cooldownOff: "Not resting",
  secQueue: "Queue",
  due: "Due now: {n}",
  delayed: "Waiting for retry time: {n}",
  oldest: "Longest-waiting due job: {n} s",
  itemsWaiting: "Invoices waiting to download / to be acknowledged: {queued} / {ack}",
  jobsByState: "Jobs by state",
  secErrors: "Errors in the last 24 hours",
  noErrors: "No errors.",
  colCode: "Error code",
  colCount: "Count",
  secHttp: "Requests to the tax portal (24 h)",
  requests: "Total requests: {n}",
  rateLimited: "Throttled 429: {n}",
  serverErrors: "Portal 5xx errors: {n}",
  clientErrors: "Other 4xx: {n}",
  latency: "Average latency: {n} ms",
  secSlices: "Per-run parameters (24 h)",
  sliceCount: "Slices run: {n}",
  sliceAvg: "Average requests per slice: {n}",
  sliceInvoices: "Invoices considered: {n}",
  sliceRss: "Peak memory: {n} MB",
  logins: "Logins: {ok}/{n} succeeded · captcha solves {c}",
  secSpool: "Result spool",
  spoolLine: "Ready: {ready} · reserved: {reserved} · {used} / {limit} MB",
  secLedger: "Fetched ledger (never re-fetched)",
  ledgerLine: "{key}: {n}",
  secCaptcha: "Captcha spend (24 h)",
  noCaptcha: "None.",
  secConnections: "Connections",
  secJobs: "Recent jobs",
  secEvents: "Error / retry / finish log (last 30 days)",
  colWhen: "When",
  colKind: "Kind",
  colState: "State",
  colAttempt: "Try",
  colRetry: "Retry in",
  colJob: "Job",
  colStage: "Stage",
  colUpdated: "Updated",
  noEvents: "No events yet.",
};
